import type { NewsItem } from "@/types/media";

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "《星河归途》口碑爆棚，科幻片迎来新一轮创作热潮",
    category: "电影资讯",
    date: "2025-10-08",
    summary:
      "上映首周便斩获超高评分，《星河归途》用扎实的剧本与震撼的视效证明，国产与合拍科幻正在走向成熟。",
    content: [
      "上周公映的科幻电影《星河归途》在观众中引发了热烈讨论。影片讲述了宇航员艾登在深空执行补给任务时，意外接收到失落殖民地信号的故事。",
      "不少影评人认为，影片最打动人的并非特效，而是对「孤独」与「归途」这两个主题的细腻刻画。导演用大量安静的镜头，让观众与主角一同感受深空的空旷与时间的重量。",
      "有业内人士指出，随着制作技术的成熟与观众审美的提升，科幻题材正迎来新一轮的创作热潮，越来越多创作者愿意在宏大设定中探讨真实的人性议题。",
      "截至目前，影片的讨论热度仍在持续攀升，相关话题多次登上社交平台热搜。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20cinematic%20feature%20image%20about%20a%20science%20fiction%20film%2C%20astronaut%20silhouette%20against%20a%20vast%20blue%20nebula%20with%20warm%20orange%20accent%2C%20dramatic%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=800&height=500&seq=cth-news-n1&orientation=landscape",
    tags: ["科幻", "口碑", "影评"],
  },
  {
    id: "n2",
    title: "悬疑剧《雾都谜案》第二季正式官宣，原班人马回归",
    category: "电视剧资讯",
    date: "2025-10-06",
    summary:
      "凭借紧凑叙事与出色摄影收获高口碑的《雾都谜案》确认续订，制作方透露第二季将揭开第一季留下的最大谜团。",
    content: [
      "去年备受好评的悬疑剧《雾都谜案》正式宣布续订第二季，主创团队与主要演员均将回归。",
      "第一季以浓雾笼罩的老城为背景，讲述退休警探哈里斯重新调查十年前悬案的故事，凭借层层反转的剧情与极具质感的画面收获了大量好评。",
      "据制作方透露，第二季的故事将紧接着第一季结尾的悬念展开，同时会引入两条新的时间线，进一步补全整个世界观。",
      "该剧预计将于明年进入正式拍摄阶段，具体播出时间尚未公布。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20moody%20image%20of%20a%20foggy%20old%20city%20street%20at%20night%2C%20deep%20blue%20mist%20with%20warm%20orange%20streetlamp%20glow%2C%20mysterious%20cinematic%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=800&height=500&seq=cth-news-n2&orientation=landscape",
    tags: ["悬疑", "续订", "英美剧"],
  },
  {
    id: "n3",
    title: "行业观察：影视内容分类与推荐系统正在变得更「懂你」",
    category: "行业动态",
    date: "2025-10-04",
    summary:
      "从简单的类型标签到多维度的内容画像，影视平台的分类与推荐正在经历一场静悄悄的革命。",
    content: [
      "过去，用户寻找一部想看的作品，往往只能依赖「电影」或「电视剧」这样的大类划分。而如今，地区、年份、题材、导演等多维度标签正在成为标配。",
      "这种变化背后，是内容数量的爆炸式增长。当可选择的作品越来越多，如何帮助用户高效地发现「想看的那一部」，就成了平台体验的核心。",
      "业内专家认为，优秀的分类与筛选体系，本质上是在尊重用户的主动权——不是被动推送，而是让用户能够按照自己的偏好自由探索。",
      "可以预见，未来影视内容的组织方式将更加立体，也更能贴合每个人独特的观影口味。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20image%20of%20a%20glowing%20digital%20grid%20of%20media%20thumbnails%2C%20deep%20blue%20background%20with%20warm%20orange%20highlights%2C%20modern%20technology%20atmosphere%2C%20high%20detail&width=800&height=500&seq=cth-news-n3&orientation=landscape",
    tags: ["行业", "推荐", "观察"],
  },
  {
    id: "n4",
    title: "历史大剧《山河故人传》收官，观众直呼「意难平」",
    category: "电视剧资讯",
    date: "2025-10-02",
    summary:
      "这部以水墨质感著称的历史剧在昨日迎来大结局，无数观众在社交平台表达不舍。",
    content: [
      "历时两个月播出的历史剧《山河故人传》昨晚正式收官。剧中那位走遍山河、记录平凡人的书生沈砚，最终完成了恩师未竟的地方志。",
      "大结局中，多年后年迈的沈砚提笔写下最后一页，镜头缓缓拉远，山河依旧，故人不再，令不少观众潸然泪下。",
      "该剧凭借厚重的历史质感、克制而深情的叙事，被不少观众称为「年度最治愈也最心碎的历史剧」。",
      "据悉，剧组正在筹备相关的幕后纪录片，将公开部分实景拍摄与美术设计的珍贵资料。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20misty%20ancient%20chinese%20mountains%20and%20rivers%20at%20dawn%2C%20deep%20blue%20ink%20washing%20tones%20with%20warm%20orange%20sunrise%2C%20poetic%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=800&height=500&seq=cth-news-n4&orientation=landscape",
    tags: ["历史剧", "收官", "口碑"],
  },
  {
    id: "n5",
    title: "国漫再出佳作，《山海幻夜》票房口碑双丰收",
    category: "电影资讯",
    date: "2025-09-30",
    summary:
      "以东方神话为底色的动画电影《山海幻夜》上映以来表现亮眼，成为本季度最受关注的国漫作品。",
    content: [
      "动画电影《山海幻夜》自上月上映以来，票房稳步攀升，口碑同样出色，被许多观众称为「近年最美的一部国漫」。",
      "影片以《山海经》为灵感，构建了一个瑰丽磅礴的幻想世界。少年为救回妹妹穿越异界的故事，既热血又温情。",
      "制作团队透露，片中大量场景参考了中国传统山水画与古建筑，力求在奇幻设定中保留东方美学的韵味。",
      "有评论认为，这部作品再次证明了国产动画在题材探索与视觉表达上的巨大潜力。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20painterly%20image%20of%20a%20mythical%20ancient%20chinese%20landscape%20at%20night%2C%20floating%20mountains%20and%20glowing%20creatures%2C%20deep%20blue%20sky%20with%20warm%20orange%20lantern%20light%2C%20high%20detail&width=800&height=500&seq=cth-news-n5&orientation=landscape",
    tags: ["国漫", "动画", "票房"],
  },
  {
    id: "n6",
    title: "《城市追光者》为何能打动这么多人？深夜群像的力量",
    category: "电视剧资讯",
    date: "2025-09-27",
    summary:
      "一部没有大牌、没有狗血桥段的都市剧，却让无数深夜还在加班的观众找到了共鸣。",
    content: [
      "正在热播的都市剧《城市追光者》，以深夜里仍在亮着灯的城市为舞台，讲述了一群普通人各自追光的故事。",
      "剧集没有刻意制造冲突，而是把镜头对准急诊室、便利店、写字楼里那些熟悉又陌生的身影，用近乎纪录片的方式呈现生活的真实质感。",
      "许多观众留言说，看着剧中人物在深夜里的坚持，仿佛看到了自己。也许正是这份真实，让它格外打动人。",
      "在快节奏的当下，这样一部愿意慢下来讲述普通人故事的作品，显得尤为珍贵。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20glowing%20city%20at%20blue%20hour%2C%20skyscrapers%20with%20warm%20orange%20window%20lights%2C%20deep%20blue%20sky%2C%20urban%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=800&height=500&seq=cth-news-n6&orientation=landscape",
    tags: ["都市剧", "群像", "热播"],
  },
  {
    id: "n7",
    title: "行业动态：经典老片修复重映成为新的观影潮流",
    category: "行业动态",
    date: "2025-09-24",
    summary:
      "越来越多经典影片以修复版的形式重返大银幕，吸引了大量年轻观众走进影院。",
    content: [
      "最近一段时间，多家影院推出了经典影片的修复重映场次，不少场次一票难求，观众中既有怀旧的老影迷，也有慕名而来的年轻人。",
      "电影修复是一项精细的工作，需要逐帧处理画面、重建音轨，往往一部影片的修复要耗费数月甚至数年。",
      "有从业者表示，修复重映不仅是致敬经典，也让新一代观众有机会在大银幕上感受电影最本真的魅力。",
      "业内人士预计，随着观众对高质量内容需求的提升，修复重映有望成为影院常态化的一种放映形式。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20vintage%20cinema%20hall%20with%20rows%20of%20seats%20and%20a%20glowing%20screen%2C%20deep%20blue%20shadows%20with%20warm%20orange%20projector%20light%2C%20nostalgic%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=800&height=500&seq=cth-news-n7&orientation=landscape",
    tags: ["修复", "重映", "行业"],
  },
  {
    id: "n8",
    title: "《孤岛信号》引发烧脑讨论，观众自发绘制时间线",
    category: "电视剧资讯",
    date: "2025-09-21",
    summary:
      "这部密闭空间科幻悬疑剧凭借严谨的设定与层层伏笔，激发了观众极大的解谜热情。",
    content: [
      "正在更新的科幻悬疑剧《孤岛信号》近日成为社交平台上的热门话题，不少观众自发整理剧情时间线，试图解开剧中不断出现的谜团。",
      "故事发生在一座孤岛科考站，八名研究员在风雪夜收到了一段带有未来时间戳的信号，随后一系列异常事件接连发生。",
      "编剧表示，剧中每一个看似随意的细节都经过了精心设计，希望观众能在反复观看中发现更多线索。",
      "这种「观众与创作者共同解谜」的互动体验，也成为该剧区别于其他悬疑作品的一大亮点。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20remote%20island%20research%20station%20at%20night%2C%20deep%20blue%20stormy%20sea%20and%20sky%2C%20warm%20orange%20radio%20tower%20glow%2C%20suspenseful%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=800&height=500&seq=cth-news-n8&orientation=landscape",
    tags: ["科幻悬疑", "烧脑", "讨论"],
  },
  {
    id: "n9",
    title: "暑期档回顾：今年观众更偏爱有诚意的故事",
    category: "行业动态",
    date: "2025-09-18",
    summary:
      "回顾刚刚过去的暑期档，题材与制作之外，「讲好一个故事」重新成为决定成败的关键。",
    content: [
      "随着暑期档落下帷幕，一份份票房与口碑数据陆续公布。与往年相比，今年的市场呈现出一些值得关注的新趋势。",
      "多位从业者观察到，观众的选择正变得越来越理性：单纯的流量与噱头不再奏效，扎实的剧本与真诚的表达，才是留住观众的关键。",
      "与此同时，类型融合的作品表现亮眼，科幻、历史、悬疑等题材都在探索属于自己的表达方式。",
      "「把故事讲好」，这句看似朴素的话，正在重新成为行业共识。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20abstract%20image%20of%20floating%20cinema%20film%20frames%20and%20light%20beams%2C%20deep%20blue%20background%20with%20warm%20orange%20highlights%2C%20modern%20creative%20atmosphere%2C%20high%20detail&width=800&height=500&seq=cth-news-n9&orientation=landscape",
    tags: ["暑期档", "市场", "回顾"],
  },
  {
    id: "n10",
    title: "《深空纪元》特效特辑发布，揭秘太空战场景的制作过程",
    category: "电影资讯",
    date: "2025-09-15",
    summary:
      "影片特效团队首次公开了那段令人印象深刻的太空舰队镜头背后的制作细节。",
    content: [
      "科幻大片《深空纪元》近日发布了特效制作特辑，重点揭秘了影片中那段广受好评的太空舰队集结镜头。",
      "据特效团队介绍，为了呈现出舰队在巨大气态行星前航行的宏大尺度感，团队参考了大量真实的航天影像与天文数据。",
      "这个仅持续数分钟的镜头，前后经历了近百个版本的调整，历时超过八个月才最终定稿。",
      "主创表示，特效的意义在于为故事服务，只有让观众相信那个世界是真实存在的，情感才能真正被传递。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20space%20image%20of%20a%20starship%20fleet%20near%20a%20giant%20blue%20gas%20planet%2C%20deep%20blue%20nebula%20with%20warm%20orange%20engine%20glow%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=500&seq=cth-news-n10&orientation=landscape",
    tags: ["特效", "幕后", "科幻"],
  },
];